<template>
  <base-modal-component>
    <template v-slot:header>
      <h4 class="u-typography-color md-title">
        {{ createOrUpdate }} Help Link
      </h4>
    </template>

    <template v-slot:body>
      <p
        v-if="error && error.messages"
        class="md-error"
      >
        {{ error.messages }}
      </p>
      <form
        novalidate
        @submit.prevent="validateUser"
      >
        <md-field :class="getValidationClass($v.helpLink.name)">
          <label for="name">Name</label>
          <md-input
            v-model="helpLink.name"
            v-focus
            name="name"
            type="name"
            class="md-input"
            autocomplete="off"
          />
          <span
            v-if="!$v.helpLink.name.required"
            class="md-error"
          >The name is required</span>
        </md-field>
        <error-response-messages :field-name="'name'" />
        <md-field :class="getValidationClass($v.helpLink.label)">
          <label for="label">Label</label>
          <md-input
            v-model="helpLink.label"
            v-focus
            name="label"
            type="label"
            class="md-input"
            autocomplete="off"
          />
          <span
            v-if="!$v.helpLink.label.required"
            class="md-error"
          >The label is required</span>
        </md-field>
        <error-response-messages :field-label="'label'" />
      </form>
    </template>
    <template v-slot:footer>
      <div class="u-mr-xs">
        <generic-button
          variation="grey"
          @click="close"
        >
          Close
        </generic-button>
      </div>
      <generic-button
        variation="red"
        @click="validateUser"
      >
        {{ createOrUpdate }}
      </generic-button>
    </template>
  </base-modal-component>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import { validationBaseMixin } from '../../../../../../mixins/ValidationBaseMixin'
import GenericButton from '../../../../../../shared/buttons/GenericButton'
import ErrorResponseMessages from '../../../../../../shared/error-response-messages/ErrorResponseMessages'
import BaseModalComponent from '../../../../../../shared/modal/BaseModalComponent'


export default {
  name: 'CreateHelpLinkModal',
  components: {
    GenericButton,
    ErrorResponseMessages,
    BaseModalComponent
  },
  mixins: [validationBaseMixin],

  props: {
    helpLink: {
      type: Object,
      required: true,
    },
    helpLinkId: {
      type: Number,
      required: false,
      default: null
    }
  },

  data() {
    return {
      messages: {
        error: null,
        success: null,
      },
    };
  },
  computed: {
    ...mapGetters("response", ["success", "error"]),

    createOrUpdate() {
      return !this.helpLinkId ? 'Create' : 'Update';
    },
  },

  validations: {
    helpLink: {
      name: {
        required
      },
      label: {
        required
      },
    },
  },

  methods: {
    ...mapActions("response", ["handleSuccess", "handleError", "resetError"]),
    ...mapActions("helpLinks", ["createHelpLink", "updateHelpLink"]),

    handleCreateHelpLink() {
      this.createHelpLink(this.helpLink);
      this.close();
    },

    handleUpdateHelpLink() {
      this.updateHelpLink({ id: this.helpLinkId, updateData: this.helpLink });
      this.close();
    },

    validateUser() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        !this.helpLinkId ? this.handleCreateHelpLink() : this.handleUpdateHelpLink();
      }
    },

    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
